<template>
  <div class="contentHome">
    <div class="centerPage">
      <tabCommon></tabCommon>
      <div class="right">
        <div class="title flex">
          <span>用户聊天</span>
          <div class="tipsComm">Tips: 单击鼠标右键可将聊天内容复制至剪切板.</div>
        </div>
        <div class="formUserInfo">
          <div class="wxchatBorderLeft">
            <h3>会话列表</h3>
            <el-input v-model="chatSearchKey" suffix-icon="el-icon-search" class="contactName"
                      placeholder="搜索联系人员" @change="getSearchKey"></el-input>
            <div class="conversationList">
              <div class="conversation flex" @click="changeChatUser(item)" v-for="(item,index) in  chatList"
                   :key="item.id + '_' + index"
                   :class="[activeChat.id==item.id?'activeChat':'',item.isTop==1?'isTopClass':'']">
                <div class="flex">
                  <el-avatar :size="40" v-if="item.chatType==1" :src="item.chatAvatarPath"></el-avatar>
                  <el-avatar :size="40" v-if="item.chatType==2" src="/static/imgs/chat_group.png"></el-avatar>
                </div>
                <div class="rightText flex">
                  <span class="chatName" v-if="item.chatType==1">{{ item.chatName }}</span>
                  <span class="chatName"
                        v-if="item.chatType==2">{{ item.chatName ? item.chatName : (item.masterName + '创建的群聊') }}</span>
                  <el-badge class="flex" :value="item.unreadNum" v-show="item.unreadNum>0"/>
                </div>
              </div>
            </div>
          </div>
          <div class="rightChat">
            <div class="wxchatBorderRightTop flex">
               <span class="chatNameActive">
              <template v-if="activeChat.chatType==1">{{ activeChat.chatName }}</template>
              <template v-if="activeChat.chatType==2"> {{
                  activeChat.chatName ? activeChat.chatName : (activeChat.masterName + '创建的群聊')
                }}</template>
            </span>
              <span v-if="activeChat.chatType==2">
              ({{ memberGroup.length }})
            </span>
              <span class="checkInfo" @click="innerDrawer = !innerDrawer">
                <img src="../../assets/img/checkInfo.png"
                     alt=""
                     width="24"></span>
            </div>
            <div class="chatContent" @click="innerDrawer=false">
              <div class="wxchatBorderRightMid" id="chatRecord">
                <p class="seeMore clickable" align="center" v-if="activeChatHistory.maxPage>activeChatHistory.current"
                   @click="showMsgHistory">---- 查看更多消息 ----</p>
                <p class="seeMore" align="center" v-else>---- 没有更多消息 ----</p>

                <el-row v-for="msg in activeChatHistory.list" :key="'his_' + msg.id">
                  <template v-if="msg.memberId == curUser.id">
                    <div align="right" class="time" style="margin-right: 7%">
                      {{ new Date(msg.msgTimestamp).Format('yyyy-MM-dd HH:mm:ss') }}
                    </div>
                    <el-col :span="22">
                      <div class="chatPop2 chatPop ">
                        <div v-if="msg.msgType === 1" @contextmenu.prevent="copyText($event)">
                          <!--                        <span v-if="isUrl(msg.msgContent)" style="float: left">链接：</span>-->
                          <a v-if="isUrl(msg.msgContent)" target="_blank"
                             :href="msg.msgContent">{{ msg.msgContent }}</a>
                          <div v-else>{{ msg.msgContent }}</div>
                        </div>
                        <div v-else-if="msg.msgType === 2">
                          <el-image
                              style="width: 100px; height: 100px"
                              :src="msg.msgContent"
                              :preview-src-list="[msg.msgContent]"
                              fit="contain"></el-image>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <el-avatar :src="memberAvatarMap.get(msg.memberId)" :size="40"></el-avatar>
                    </el-col>
                  </template>
                  <template v-else>
                    <div align="left" class="time" style="margin-left: 7%">
                      {{ new Date(msg.msgTimestamp).Format('yyyy-MM-dd HH:mm:ss') }}
                    </div>
                    <el-col :span="2">
                      <el-avatar :src="memberAvatarMap.get(msg.memberId)" :size="40"></el-avatar>
                    </el-col>
                    <el-col :span="22">
                      <div class="chatPop1 chatPop">
                        <div v-if="msg.msgType === 1" @contextmenu.prevent="copyText($event)">
                          <!--                        <span v-if="isUrl(msg.msgContent)" style="float: left">链接:</span>-->
                          <a v-if="isUrl(msg.msgContent)" target="_blank"
                             :href="msg.msgContent">{{ msg.msgContent }}</a>
                          <div v-else>{{ msg.msgContent }}</div>
                        </div>
                        <div v-else-if="msg.msgType === 2">
                          <el-image
                              style="width: 100px; height: 100px"
                              :src="msg.msgContent"
                              :preview-src-list="[msg.msgContent]"
                              fit="contain"></el-image>
                        </div>
                      </div>
                    </el-col>
                  </template>
                </el-row>
              </div>
              <div class="wxchatBorderRightBottom">
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="msgContent"
                          resize="none" autofocus maxlength="500">
                </el-input>
                <div class="sendButton">
                  <el-button size="mini" class="custom" @click="clickImgBtn()">上传图片</el-button>
                  <el-button size="mini" @click="sendTextMessage()">发送</el-button>
                </div>
                <div style="clear: both"></div>
              </div>
            </div>
            <transition name="el-fade-in-linear">
              <div v-show="innerDrawer" class="transition-box ">
                <template v-if="activeChat.chatType==2">
                  <el-input v-model="groupMemSearch" suffix-icon="el-icon-search" class="contactName"
                            placeholder="搜索群成员" @change="getSearchMember"></el-input>
                  <div class="memberGroupList">
                    <div class="conversation flex" v-for="(item,index) in  memberGroup"
                         :key="item.id + '_' + index" v-show="isOpen || index < max">
                      <el-avatar :size="36" fit="cover" :src="item.memberHeadImg"></el-avatar>
                      <div class="rightText flex ">
                        <span class="chatName">
                          {{ item.nickname }}
                        </span>
                        <span class="manager" v-if="item.memberId ==  activeChat.masterId">@群主</span>
                      </div>
                    </div>
                  </div>
                  <p class="moreCheck" v-show="!isOpen && memberGroup.length > max" @click="isOpen = !isOpen">查看更多群成员
                    <i class="el-icon-arrow-down"></i></p>
                  <p class="moreCheck" v-show="isOpen && memberGroup.length > max" @click="isOpen = !isOpen">收起 <i
                      class="el-icon-arrow-up"></i></p>
                </template>
                <div class="activeChatUser flex" v-else>
                  <el-avatar :size="36" fit="cover" :src="activeChat.chatAvatarPath"></el-avatar>
                  <span class="chatName"> {{ activeChat.chatName }}</span>
                </div>
                <div class="flex operation">
                  <span>消息免打扰</span>
                  <el-switch
                      @change="disturbClick"
                      v-model="operation.showStatus"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#567BFF"
                      inactive-color="#C5CBDF">
                  </el-switch>
                </div>
                <div class="flex operation">
                  <span>置顶聊天</span>
                  <el-switch
                      @change="topClick"
                      v-model="operation.isTop"
                      :active-value="1"
                      :inactive-value="0"
                      active-color="#567BFF"
                      inactive-color="#C5CBDF">
                  </el-switch>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <input id="el_copy_input" style="display: none;border: none;color: transparent;" type="text" v-model="copy_input"/>
    <input id="img_file_input" type="file" ref="uploadImageInput" accept="image/png,image/jpeg,image/gif,image/jpg"
           style="display: none;" @change="sendImageMessage()"/>


  </div>

</template>

<script>
import base from '@/api/common'

export default {
  name: "communicate",
  data() {
    return {
      curUser: {
        id: localStorage.curUid,
      },
      redirectId: this.$route.params.id,
      chatList: [],
      chatSearchKey: '',//搜索条件
      chat: {
        current: 1,
        size: 10
      },
      loading: false,
      activeChat: {
        id: '',
      },
      activeChatHistory: {
        chatId: '',
        list: [],
        current: 1,
        size: 10,
        total: 0,
        maxPage: 1,
      },
      msgContent: '', // 文本域聊天内容
      memberAvatarMap: new Map(),
      chatListIndexMap: new Map(),
      msgTimer: 0,
      copy_input: '',
      unreadNum: 0,

      innerDrawer: false,
      groupMemSearch: '',
      memberGroup: [],
      isOpen: false,
      max: 4,
      operation: {
        showStatus: 0,
        isTop: 0
      }
    }
  },
  components: {
    'tabCommon': () => import('./tabCommon'),
  },
  inject: ['reload'],
  mounted() {
    // 1. 加载聊天列表
    let that = this;
    that.getChatList();

    // 获取新消息
    if (that.msgTimer) {
      return;
    }
    let chat_failCount = 0;
    that.msgTimer = setInterval(() => {
      if (chat_failCount >= 10) {
        clearInterval(that.msgTimer);
        return;
      }
      that.$ajax.post(base.api.communication.chat.unreadList).then(res => {
        if (res.data.status === 'success') {
          res.data.list.forEach(item => {
            let index = that.chatListIndexMap.get(item.chatId);
            if (index || index === 0) {
              that.chatList[index].unreadNum = item.unreadNum;
            }
            // 获取新消息
            if (that.activeChat.id === item.chatId) {
              that.getChatHistory(item.chatId, true);
              // 此时清空未读
              that.clearUnreadChar(item.chatId);
            }
          })
        }
      }).catch(err => {
        chat_failCount++;
        console.error(err);
      })
    }, 2000);
  },
  destroyed() {
    clearInterval(this.msgTimer);
  },
  methods: {
    copyText(e) {
      this.copy_input = $(e.target).text();
      document.getElementById('el_copy_input').style.display = 'block';
      this.$nextTick(() => {
        document.getElementById('el_copy_input').select();
        document.execCommand("copy");
        document.getElementById('el_copy_input').style.display = 'none';
      });
      this.$message.success('内容复制成功');
    },

    async changeChatUser(item) {
      this.innerDrawer = false
      if (item && item.id) {
        if (this.activeChat.id == item.id) {
          return;
        }
        this.activeChatHistory.list.length = 0;
        this.activeChat = item;
        this.operation.showStatus = this.activeChat.showStatus
        this.operation.isTop = this.activeChat.isTop
        await this.getMemberList(item.id);
        this.getChatHistory(item.id);
        this.clearUnreadChar(item.id);
      }
    },
    // 获取聊天列表
    getChatList() {
      let that = this;
      that.$ajax.get(base.api.communication.chat.list_me.replace('{pg}', that.chat.current).replace('{ps}', that.chat.size) + '?name=' + that.chatSearchKey)
          .then(async res => {
            if (res.data.status === 'success') {
              // let list = res.data.list;
              let list = []
              list.push(...res.data.rows);
              // 先清空会话
              that.chatList.length = 0;
              let createActive = false;
              list.forEach((item, index) => {
                that.chatListIndexMap.set(item.id, index);
                // 显示处理
                if (item.chatType == 1) { //私聊
                  if (that.curUser.id == item.masterId) {
                    item.chatName = item.inviteeName;
                    item.chatAvatarPath = item.inviteeAvatar;
                  } else {
                    item.chatName = item.masterName;
                    item.chatAvatarPath = item.masterAvatar;
                  }
                }
                // 新回话置顶处理
                if (that.redirectId && item.id == that.redirectId) {
                  if (that.chat.current == 1) {
                    createActive = true;
                    that.chatList.unshift(item);
                  } else {
                    list.splice(index, 1);
                    that.chatList.unshift(item);
                  }
                } else {
                  that.chatList.push(item);
                }
              });

              if (that.redirectId && !createActive) { // 从私信==>未激活聊天
                // 单独添加
                await that.$ajax.get(base.api.communication.chat.one.replace('{id}', that.redirectId)).then(res => {
                  if (res.data.status === 'success') {
                    let topChat = res.data.data;
                    if (topChat.chatType == 1) { //私聊
                      if (that.curUser.id == topChat.masterId) {
                        topChat.chatName = topChat.inviteeName;
                        topChat.chatAvatarPath = topChat.inviteeAvatar;
                      } else {
                        topChat.chatName = topChat.masterName;
                        topChat.chatAvatarPath = topChat.masterAvatar;
                      }
                    }
                    if (that.chat.current == 1) {
                      that.chatList.unshift(topChat);
                    }
                    // 选中首个
                    that.selectTop();
                  }
                })
              }
              // 选中首个
              that.selectTop();
            } else {
              that.$message.error('信息加载失败');
            }
          }).catch(err => {
        console.error(err);
        that.$message.error('信息加载失败');
      });
    },
    // 置顶
    selectTop() {
      // 2. 选中首个
      let that = this;
      if (that.activeChat && that.activeChat.id) {
        return;
      }
      that.$nextTick(async () => {
        if (that.chatList.length > 0) {
          that.activeChat = that.chatList[0];
          // 获取成员信息
          await that.getMemberList(that.chatList[0].id);

          // 获取聊天记录
          that.getChatHistory(that.chatList[0].id, true);
        }
      });
    },
    // 查看更多
    showMsgHistory() {
      let that = this;
      that.activeChatHistory.current++;
      that.getChatHistory(that.activeChat.id);
    },
    // 获取历史记录
    getChatHistory(id, sb) { // sb: scroll to bottom
      let that = this;
      that.activeChatHistory.chatId = id;
      that.$ajax.get(base.api.communication.chat.message.replace('{id}', id) + '?page=' + that.activeChatHistory.current).then(res => {
        if (res.data.status === 'success') {
          if (that.activeChatHistory.current == 1) {
            that.activeChatHistory.list.length = 0;
          }
          that.activeChatHistory.list = [...res.data.rows.reverse(), ...that.activeChatHistory.list];
          that.activeChatHistory.current = res.data.current;
          that.activeChatHistory.size = res.data.size;
          that.activeChatHistory.total = res.data.total;
          that.activeChatHistory.maxPage = Math.ceil(res.data.total / res.data.size);
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('聊天信息加载失败');
      });
    },
    // 获取成员信息
    async getMemberList(id) {
      let that = this, url;
      if (!this.groupMemSearch) {
        url = base.api.communication.chat.member.list.replace('{id}', id)
      } else {
        url = base.api.communication.chat.member.name.replace('{id}', id) + '?name=' + this.groupMemSearch
      }
      await that.$ajax.get(url).then(async res => {
        if (res.data.status === 'success') {
          this.memberGroup = res.data.list
          res.data.list.forEach((item, index) => {
            that.memberAvatarMap.set(item.memberId, item.memberHeadImg);
            if (item.memberId == this.activeChat.masterId) {
              that.memberGroup.splice(index, 1)
              that.memberGroup.unshift(item);
            }
          })
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('成员信息加载失败');
      })

    },
    // 清除未读
    clearUnreadChar(chatId) {
      this.$ajax.post(base.api.communication.chat.cleanChatUnread.replace('{id}', chatId));
      // 当前消息清空本地数量
      let index = this.chatListIndexMap.get(chatId);
      this.chatList[index].unreadNum = this.unreadNum;
    },
    // 发送消息
    sendTextMessage() {
      let that = this;
      if (!that.activeChat.id) {
        that.$message.info('发送对象不能为空');
        return;
      }
      let msgContent = that.msgContent;
      if ($.trim(msgContent).length === 0) {
        that.$message.info('内容不能为空');
        return;
      }
      that.$ajax.post(base.api.communication.chat.sendText.replace('{id}', that.activeChat.id), {
        msgContent
      }).then(res => {
        if (res.data.status === 'success') {
          that.activeChatHistory.list.length = 0;
          that.activeChatHistory.current = 1;
          that.getChatHistory(that.activeChat.id, true); //刷新聊天数据
          that.msgContent = '';
        } else {
          that.$message.error('发送失败');
        }
      }).catch(err => {
        that.$message.error('发送失败');
      });
    },
    clickImgBtn() {
      $('#img_file_input').click();
    },
    sendImageMessage() {
      let inputEle = this.$refs.uploadImageInput;
      let files = inputEle.files;
      if (files.length == 0) {
        return;
      }
      let that = this;

      let formData = new FormData();
      formData.append('uploadFile', files[0]);

      this.$ajax.post(base.api.communication.chat.sendImg.replace('{id}', that.activeChat.id), formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        if (res.data.status === 'success') {
          that.activeChatHistory.list.length = 0;
          that.activeChatHistory.current = 1;
          that.getChatHistory(that.activeChat.id, true); //刷新聊天数据
          that.msgContent = '';
        } else {
          that.$message.error('发送失败');
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('发送失败');
      });
    },
    isUrl(strUrl) {
      let strRegex = '^((https|http|ftp)://)?'//(https或http或ftp):// 可有可无
          + '(([\\w_!~*\'()\\.&=+$%-]+: )?[\\w_!~*\'()\\.&=+$%-]+@)?' //ftp的user@  可有可无
          + '(([0-9]{1,3}\\.){3}[0-9]{1,3}' // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
          + '|' // 允许IP和DOMAIN（域名）
          + '(localhost)|'	//匹配localhost
          + '([\\w_!~*\'()-]+\\.)*' // 域名- 至少一个[英文或数字_!~*\'()-]加上.
          + '\\w+\\.' // 一级域名 -英文或数字  加上.
          + '[a-zA-Z]{1,6})' // 顶级域名- 1-6位英文
          + '(:[0-9]{1,5})?' // 端口- :80 ,1-5位数字
          + '((/?)|' // url无参数结尾 - 斜杆或这没有
          + '(/[\\w_!~*\'()\\.;?:@&=+$,%#-]+)+/?)$';//请求参数结尾- 英文或数字和[]内的各种字符
      let re = new RegExp(strRegex, 'i');//i不区分大小写
      if (re.test(encodeURI(strUrl))) {
        return true;
      } else {
        return false;
      }
    },
    removeUrlParams(url) {
      if (!url) {
        return ''
      }
      return url.split('/')[2];
    },
    // 搜索聊天列表
    getSearchKey(value) {
      this.chatSearchKey = value
      this.chatList.length = 0;
      this.getChatList()
    },
    // 搜索成员列表
    getSearchMember(value) {
      this.groupMemSearch = value
      this.memberGroup.length = 0;
      this.getMemberList(this.activeChat.id)
    },
    // 免打扰
    disturbClick() {
      let that = this;
      that.$ajax.post(base.api.communication.chat.disturb.replace('{id}', that.activeChat.id).replace('{status}', that.operation.showStatus))
          .then((res) => {
            if (res.data.status == 'success') {
              that.getChatList()
              this.innerDrawer = false
            }
          });
    },
    // 置顶
    topClick() {
      let that = this;
      that.$ajax.post(base.api.communication.chat.setTop.replace('{id}', that.activeChat.id).replace('{status}', that.operation.isTop))
          .then((res) => {
            if (res.data.status == 'success') {
              this.getChatList()
              this.innerDrawer = false
            }
          });
    }
  },
  watch: {
    activeList(val, oldVal) {
      if (oldVal.length === 0) {
        this.$nextTick(() => {
          document.querySelector("#chatRecord").scrollTop = document.querySelector("#chatRecord").scrollHeight;
        })
      }
    }
  },
  computed: {
    activeList() {
      return this.activeChatHistory.list;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/communicate.scss";

</style>
